module.exports = __webpack_public_path__ + "static/img/416.bb11b9a.png";